import { render } from "./ViewHeader.vue?vue&type=template&id=3273857a&scoped=true&ts=true"
import script from "./ViewHeader.vue?vue&type=script&lang=ts"
export * from "./ViewHeader.vue?vue&type=script&lang=ts"

import "./ViewHeader.vue?vue&type=style&index=0&id=3273857a&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3273857a"]])

export default __exports__